// extracted by mini-css-extract-plugin
export var fullGrid = "_34-3";
export var pdpPreviewContainer = "_34-1";
export var previewContainer = "_34-0";
export var togglePreviewContainer = "_34-2";